/* Complemento de assets/lah-frameonly.js — comparativo opcional em
   "outra otica". Arquivo separado para que o comparativo possa ser removido
   sozinho, sem tocar na tela de motivos. */

(function () {
    'use strict';

    var overlay = document.getElementById('lah-frameonly');
    if (!overlay) return;

    var panel = overlay.querySelector('[data-lah-fo-estimate-panel]');
    if (!panel) return;

    function track(eventName, payload) {
        try {
            window.dataLayer = window.dataLayer || [];
            window.dataLayer.push(Object.assign({ event: eventName }, payload || {}));
        } catch (e) { /* analytics nunca deve quebrar a venda */ }
    }

    overlay.addEventListener('click', function (event) {
        var toggle = event.target.closest('[data-lah-fo-estimate]');
        if (toggle) {
            var opening = !panel.classList.contains('is-open');
            panel.classList.toggle('is-open', opening);
            if (opening) track('lens_frameonly_estimate_open', {});
            return;
        }

        var grauBtn = event.target.closest('[data-lah-fo-grau]');
        if (!grauBtn) return;

        var grau = grauBtn.getAttribute('data-lah-fo-grau');

        Array.prototype.forEach.call(
            overlay.querySelectorAll('[data-lah-fo-grau]'),
            function (btn) {
                btn.classList.toggle('is-active', btn === grauBtn);
            }
        );

        Array.prototype.forEach.call(
            overlay.querySelectorAll('[data-lah-fo-result]'),
            function (result) {
                result.classList.toggle(
                    'is-active',
                    result.getAttribute('data-lah-fo-result') === grau
                );
            }
        );

        track('lens_frameonly_estimate_grau', { grau: grau });
    });
})();
